import { render, staticRenderFns } from "./IndustryTab.vue?vue&type=template&id=3f8130fe"
import script from "./IndustryTab.vue?vue&type=script&lang=js"
export * from "./IndustryTab.vue?vue&type=script&lang=js"
import style0 from "./IndustryTab.vue?vue&type=style&index=0&id=3f8130fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports